import { HttpErrorResponse } from '@angular/common/http';
import { IUpdateCriticalInfo } from '@app/modules/critical-info/interface/critical-info';
import { CRITICAL_INFO_DIALOG_MODE } from '@app/modules/critical-info/consts/dialog-mode';

export namespace CriticalInfoActions {
  /**
   * @action CheckBlockers
   */
  export class CheckBlockers {
    static type = '[CriticalInfo] CheckBlockers';
    constructor(public skipProxy: boolean = false) {}
  }

  /**
   * @action GetStorageData
   */
  export class GetStorageData {
    static type = '[CriticalInfo] GetStorageData';
  }

  /**
   * @action SwitchDialogModel
   */
  export class SwitchDialogModel {
    static type = '[CriticalInfo] SwitchDialogModel';
    constructor(public dialogMode: CRITICAL_INFO_DIALOG_MODE) {}
  }

  /**
   * @action ToggleDialogModel
   */
  export class ToggleDialogModel {
    static type = '[CriticalInfo] ToggleDialogModel';
  }

  /**
   * @action GetCriticalInfo
   */
  export class GetCriticalInfo {
    static type = '[CriticalInfo] GetCriticalInfo';
  }
  export class GetCriticalInfoSuccess {
    static type = '[CriticalInfo] GetCriticalInfoSuccess';
  }
  export class GetCriticalInfoFailed {
    static type = '[CriticalInfo] GetCriticalInfoFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateCriticalInfo
   */
  export class UpdateCriticalInfo {
    static type = '[CriticalInfo] UpdateCriticalInfo';
    constructor(public model: IUpdateCriticalInfo) {}
  }
  export class UpdateCriticalInfoSuccess {
    static type = '[CriticalInfo] UpdateCriticalInfoSuccess';
  }
  export class UpdateCriticalInfoFailed {
    static type = '[CriticalInfo] UpdateCriticalInfoFailed';
    constructor(public error?: HttpErrorResponse) {}
  }
}
